module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name,
      "min": true
    }
  }, [_c('div', {
    staticClass: "bar-wrap"
  }, _vm._l((_vm.tableData), function(item, index) {
    return (_vm.tableData.length > 0 && index < 6) ? _c('div', {
      staticClass: "temp"
    }, [_c('img', {
      key: item.productUrl,
      attrs: {
        "src": ("" + _vm.url + (item.productUrl.split(',')[0]))
      }
    }), _vm._v(" "), _c('span', {
      key: item.productName
    }, [_vm._v(_vm._s(item.productName))])]) : _vm._e()
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-508ab70b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/trace/components/product/index.vue
// module id = 1999
// module chunks = 2